<template>
  <div class="orderList">
    <div class="head">
        <div style="flex:9;padding-left:20px;">
          <span style="flex:9;">订单详情</span>
        </div>
        <div style="flex:8;padding-right:20px;">
          <span style="flex:1;">收货人</span>
          <span style="flex:1;">实付款</span>
          <span style="flex:1;">状态</span>
          <span style="flex:1;">操作</span>
        </div>
    </div>
    <div v-if="orderList.list.length>0">
      <div class="content" v-for="(item,index) in orderList.list" :key="index">
          <div class="top">
              <div class="left">
                  <!-- <span class="shopName" @click="toStore(item.shopId)"><img :src="item.shopLogo" alt="">{{item.shopName}}</span> -->
                  <span class="time">{{item.createTime}}</span>
                  <span class="orderCode">订单号：{{item.orderCd}}</span>
              </div>
              <div class="right">
                  <img class="cur-poi" v-if="item.state==5" src="../../../static/image/shanchu@2x.png" alt="" @click="$emit('isDelete',item.orderId)">
              </div>
          </div>
          <div class="productBox">
              <div class="product">
                  <div class="left fs13">
                      <div class="box" v-for="(items,indexs) in item.cartInfo" :key="indexs">
                          <div class="desc cur-poi" @click="toProductDetail(items)">
                              <div style="border:1px solid #efefef;margin-right: 10px;">
                                <img :src="items.productInfo.image" alt="">
                              </div>
                              <div>
                                  <p class="name">{{items.productInfo.storeName}}</p>
<!--                                   <p class="size font-color-999"><span v-if="items.productInfo.attrInfo">{{items.productInfo.attrInfo.sku}}</span></p>-->
                              </div>
                          </div>
                          <div class="price" v-if="items.truePrice">¥{{items.truePrice}}</div>
                          <div class="num">{{'×'+items.cartNum}}</div>
                      </div>
                  </div>
                  <!-- <div class="right" :class="item.skus.length>1?'right_line':''"> -->
                    <div class="right">
                      <div class="consignee">{{item.realName}}</div>
                      <div class="actualPay"><div>
                          <p class="fs13 mar-bot-5">¥{{item.payPrice}}</p>
                          <p class="fs13">(含运费：¥{{item.totalPostage.toFixed(2)}})</p>
                      </div>
                      </div>
                      <div class="status">
                      <div>
                          <div>
                                <p class="fs13 mar-bot-5 font-color-FF7" v-if="item.status==0&&item.payType=='payByArrive'">货到付款</p>
                                <p class="fs13 mar-bot-5 font-color-FF7" v-else-if="item.status==0&&item.payType!='payByArrive'&&item._status._type==0">待支付</p>
                                <p class="fs13 mar-bot-5 font-color-FF7" v-if="item._status._type==1" >待发货</p>
                                <p class="fs13 mar-bot-5 font-color-FF7" v-if="item._status._type==2">待收货</p>
                                <p class="fs13 mar-bot-5 font-color-71B" v-if="item.status==2">待评价</p>
                                <p class="fs13 mar-bot-5 font-color-999" v-if="item.status==3">已完成 </p>
                                <p class="fs13 mar-bot-5 font-color-999" v-if="item.status==-1">退款中 </p>
                                <p class="fs13 mar-bot-5 font-color-999" v-if="item.status==-2">已退款 </p>
                                <p class="fs13 mar-bot-5 font-color-999" v-if="item.status==-2">退款 </p>
                                <p class="fs13 cur-poi" @click="toOrderDetail(item.orderId)">订单详情</p>
                          </div>
                        <!-- 订单状态（-1 : 申请退款 -2 : 退货成功 0：待发货；1：待收货；2：已收货；3：已完成；-1：已退款） -->
                      </div>
                      </div>
                      <div class="operate">
                          <div v-if="item._status._type!=-2">
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.paid==0 && item.payType!='payByArrive' && item._status._type==0" @click="getUrl(item)" v-throttle>去付款</el-button>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item._status._type==1" @click="remind(item.orderId)" v-throttle>提醒发货</el-button>
                              <el-button class="fs13 mar-bot-5" size="small" v-if="item._status._type==2" @click="$emit('isConfirm',item.orderId)" v-throttle>确认收货</el-button>
<!--                              <el-button class="fs13 mar-bot-5" size="small" v-if="item.status==4 || item.state==5" @click="buyAgain(item.orderId)" v-throttle>再次购买</el-button>-->
                              <p class="fs13 tex-und cur-poi" @click="$emit('isCancel',item.orderId)" v-if="item.status == 5 || item.status == 0" v-throttle>取消订单</p>
                              <!-- <p class="fs13 tex-und cur-poi" @click="$emit('isRefund',item)" v-if="item._status._type!=0&&item.payType!='payByArrive'&&refundStatus!=2&&refundStatus!=1 ||item.status == 2" v-throttle>退货/退款</p> -->
<!--                                 <p class="fs13 tex-und cur-poi" @click="$emit('isRefund',item)" v-if="item._status._type!=0&&item.payType!='payByArrive'&&item.refundStatus!=2&&item.refundStatus!=1 ||item.status == 2" v-throttle>退货/退款</p>-->

                              <!-- <p class="fs13 tex-und cur-poi" v-if="refundStatus!=0&&refundStatus!=''" v-throttle>正在退货/退款</p> -->
                              <p class="fs13 tex-und cur-poi" v-if="item.status==2"  @click="toEvaluate(item)" v-throttle>评价</p>
                              <p class="fs13 tex-und cur-poi" v-if="item._status._type==2" @click="toOrderDetail(item.orderId)" v-throttle>查看物流</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <el-pagination :current-page="page" :page-size="5" @current-change="handleCurrentChange" background layout='prev, pager, next' :total='orderList.total'></el-pagination>
    </div>
    <div class="noorder" v-else>
        <img src="../../../static/image/noorder@2x.png" alt="">
        <p class="fs20 font-color-999">你还没有订单哦～</p>
        <router-link to="/">
            <el-button>去首页看看</el-button>
        </router-link>
    </div>
	<el-dialog
	  class="weChat"
	  :title="`请使用${payTitle}扫一扫支付实际付款： ￥${payInfo.money}`"
	  :visible.sync="weChatDialog"
	  :before-close="handleClose"
	  width="30%">
	  <div class="weChatBox">
	    <div class="qCode">
	          <div id="qrcode" ref="qrcode"></div>
	      <img style="float: left;" :src="payTypeImg" alt="">
	    </div>
	    <div class="weChatInfo">
	      <img :src="payImg" alt="">
	    </div>
	  </div>
	</el-dialog>
    <!-- <el-dialog
      class="weChat"
      :title="`请使用微信扫一扫支付￥${payInfo.money}`"
      :visible.sync="weChatDialog"
      :before-close="handleClose"
      width="30%">
      <div class="weChatBox">
        <div class="qCode">
          <img :src="payInfo.url" alt="">
          <img src="../../assets/images/weiXintit.png" alt="">
        </div>
        <div class="weChatInfo">
          <img src="../../assets/images/imgPay.png" alt="">
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import api from '../../api'
import QRCode from 'qrcodejs2'
import {listSearchMixin} from '../../config/mixin'
export default {
    props: ['orderList', 'page'],
    mixins: [listSearchMixin],
    data () {
        return {
          payInfo: {},
          weChatDialog: false,
          chatTimer: '',
		  payTypeImg: '',
		  payImg: '',
		  payTitle: ''
        }
    },
    created () {
    },
    methods: {
        ...mapMutations({
          setCurrentPro: 'SET_CURRENTPRO',
          setCartNumber: 'SET_CARTNUMBER',
          setShoppingCart: 'SET_SHOPPINGCART'
        }),
        // 跳转到商品详情
        toProductDetail (item) {
          item.id = item.productId
          this.setCurrentPro(item)
          // this.$router.push({path: '/productDetail',query:{productId:item.productId}})
          this.$router.push({path: '/productDetail?productId='+item.storeCode})
        },
        // 分页器跳转
        handleCurrentChange (val) {
            this.$emit('handleCurrentChange', val)
        },
        // 提醒发货
        remind (id) {
            this.$message({
              message: '已提醒卖家发货',
              type: 'success'
            })
        },
        // 跳转到店铺
        toStore (id) {
            this.$router.push({
                path: '/store',
                query: {
                    // shopData: {shopId: id}
					productId: id
                }
            })
        },
        // 跳转到订单详情
        toOrderDetail (id) {
            this.$router.push({
                path: '/orderDetail',
                query: {
                    orderId: id
                }
            })
        },
        // 再次购买
        buyAgain (id) {
            let self = this
            let params = {
                url: api.buyAgain,
                method: 'PUT',
                data: {
                  orderId: id
                }
            }
            self.sendReq(params, (res) => {
              if (res.success) {
                 self.$router.push('/shopping-trolley')
              } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
            })
        },
        // 跳转到评价
        toEvaluate (data) {
            this.$router.push({
                path: '/evaluate',
                query: {
                    product: JSON.stringify(data)
                }
            })
        },
        // 去支付
      checkPay (paramsData) {
        setTimeout(() => {
          let self = this
          let params = {
            url: api.checkPay,
            method: 'GET',
            data: {
              orderId: paramsData.orderId,
              type: '2'
            }
          }
          self.sendReq(params, (res) => {
            if (res.success) {
              if (res.data.cod === 'SUCCESS') {
                self.$message({
                  message: '支付成功！',
                  type: 'success'
                })
                clearInterval(self.chatTimer)
                self.getTrolleyList()
                self.weChatDialog = false
                self.toOrderDetail(paramsData.orderId)
              }
            } else {
              clearInterval(self.chatTimer)
              self.$message({
                message: res.message,
                type: 'error'
              })
              self.weChatDialog = false
            }
          })
        }, 0)
      },
      // 购物车列表
      async getTrolleyList () {
        const vm = this
        const params = {
          url: api.getTrolleyList,
          method: 'GET'
        }
        vm.sendReq(params, res => {
          const d = res.data
          let cartNumber = 0
          if (d.length) {
            d.forEach(j => {
              cartNumber = cartNumber + j.skus.length
            })
          }
          this.setShoppingCart(d)
          this.setCartNumber(cartNumber)
        })
      },
	  qrcodeScan (url) {//生成二维码
	  	  let qrcode = new QRCode('qrcode', {
	  	      width: 200,  // 二维码宽度
	  	      height: 200, // 二维码高度
	  	      text: url
	  	  })
	  	},
      // 去支付
      getUrl (item) {
        let self = this
		let params = {
		  url: api.orderSubmit+"/"+item.unique,
		  method: 'POST',
		  data: {
			  payType: item.payType,
			  // from: ''
		  }
		}
        self.sendReq(params, (res) => {
          if (res.success) {
            self.payInfo = res.data
            self.payInfo.url = res.data.result;
             self.payInfo.money=res.data.money

			 if(res.data.payType=="alipay"){
			    this.payTypeImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/db8b8dfbdd8d4a1db192c7b1f6bfe158aliIntit.png";
			    this.payImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/6af28324354042e2b82113bedee6392fimgPayAli.png";
			    this.payTitle="支付宝"
			 }else if(res.data.payType=="weChat"){
			   this.payTypeImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/30c7e89a9d82494abbfa83cc55960986weiXintit.png";
			   this.payImg="http://slwmall.oss-cn-beijing.aliyuncs.com/admin/2021-03-15/80a60f2ea10a4c52ba05df93748cdc4bimgPay.png";
			   this.payTitle="微信"
			 }

            if(item.payType=="payByArrive"){
              clearInterval(this.chatTimer)
              this.$router.push({path: '/myOrder'})
            }else{

            }
            if(res.data.payType=="alipay"||res.data.payType=="weChat"){
                  this.$nextTick (function () {
                                this.qrcodeScan(res.data.result);
                              })
                            self.weChatDialog = true
                            self.chatTimer = setInterval(() => {
                              self.checkPay1(res.data)
                            }, 3000)
            }
          } else {
            self.$message({
              message: res.message,
              type: 'warning'
            })
          }
        })
      },
	  checkPay1 (paramsData) {
	    setTimeout(() => {
	      let self = this
	      let params = {
	        url: api.getOrderDetail+"/"+paramsData.orderId,
	        method: 'GET',
	        data: {
	          orderId: paramsData.orderId,
	          type: '1'
	        }
	      }
	      self.sendReq(params, (res) => {
	        if (res.data._status._type==1) {
	            self.$message({
	              message: '支付成功！',
	              type: 'success'
	            })
				this.weChatDialog = false
				this.$refs.qrcode.innerHTML = ''
	            clearInterval(self.chatTimer)
	            self.getTrolleyList()
	            self.$router.push({path: '/myOrder'})
	        } else {
	         // clearInterval(self.chatTimer)
	          // self.$message({
	          //   message: res.message,
	          //   type: 'error'
	          // })
	        }
	      })
	    }, 0)
	  },
      handleClose () {
        this.$confirm('确认取消支付？')
          .then(_ => {
            clearInterval(this.chatTimer)
            this.weChatDialog = false
			this.$refs.qrcode.innerHTML = ''
          })
          .catch(_ => {})
      }
    }
}
</script>
<style lang="scss" scoped>
.orderList{
    width: 100%;
    .noorder{
        width: 100%;
        text-align: center;
        padding: 100px 0;
        p{
            margin-bottom: 20px;
        }
        .el-button{
            background-color: #D22929;
            color: #FFFFFF;
            font-weight: normal;
            border-radius: 0;
        }
    }
    .head{
        box-sizing: border-box;
        margin-bottom: 5px;
        width: 100%;
        font-size: 12px;
        height: 33px;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        text-align: center;
        color: #666;
        div{
            display: flex;
        }
    }
    .content{
        width: 100%;
        margin-bottom: 20px;
        border: 1px solid #E5E5E5;
        border-bottom: 0;
        box-sizing: border-box;
        .top{
            width: 100%;
            font-size: 10px;
            height: 31px;
            display: flex;
            //justify-content: space-between;
            align-items: center;
            background: #f5f5f5;
            .left{
                padding-left: 20px;
                flex: 15;
                .shopName{
                    margin-left: 20px;
                    margin-right: 60px;
                    cursor: pointer;
                    img{
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        margin-right: 5px;
                        padding: 5px;
                    }
                }
                .time{
                    margin-right: 60px;
                    color: #aaa;
                }
            }
            .right{
                flex: 2;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-right: 20px;
            }
        }
        .productBox{
            width: 100%;
            box-sizing: border-box;
            .product{
                width: 100%;
                display: flex;
                .left{
                    flex: 9;
                    .box{
                        padding: 4px 0 4px 4px;
                        display: flex;
                        border-bottom: 1px solid #E5E5E5;
                        .desc{
                            flex: 5;
                            display: flex;
                            img{
                                width: 50px;
                                height: 50px;
                            }
                            div{
                                display: flex;
                                //flex-direction: column;
                                justify-content: space-between;
                                .name{
                                    padding-top: 5px;
                                    font-size: 10px;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    min-width: 250px;
                                    width: 250px;
                                    height: 50px;
                                    &:hover {
                                      color:red;
                                    }
                                }

                                .size{
                                    font-size: 10px;
                                    span{
                                        margin-right: 10px;
                                    }
                                    span:last-child{
                                        margin-right: 0;
                                    }
                                }
                            }
                        }
                        .price,.num{
                            flex: 2;
                            display: flex;
                            font-size: 10px;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                .right{
                    padding: 0px 4px 0px 0;
                    flex: 8;
                    display: flex;
                    border-bottom: 1px solid #E5E5E5;
                    .operate {
                      &:hover {
                        color:blue;
                      }
                    }
                    .actualPay,.consignee,.status,.operate{
                        font-size: 10px;
                        flex: 1;
                        border-left: 1px solid #E5E5E5;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p{
                          font-size: 10px;
                        }
                        div{
                            text-align: center;
                            .el-button{
                                border: 1px solid #D22929;
                                color: #D22929;
                                border-radius: 0;
                            }
                        }
                    }
                }
                .right_line{
                    border-left: 1px solid #E5E5E5;
                }
            }
        }
    }
    >>>.el-pagination{
        margin-top: 40px;
        text-align: right;
        .el-pager{
            li:not(.disabled):hover{
                color: #D22929;
            }
            li:not(.disabled).active{
                background-color: #D22929;
            }
            li:not(.disabled).active:hover{
                color: #F4F4F5;
            }
        }
    }
  .weChatBox {
    display: flex;
    img {
      width: 100%;
    }
    .qCode {
      width: 50%;
      text-align: center;
      img {
        width: 80%;
      }
    }
    .weChatInfo {
      width: 50%;
    }
  }
  .weChat {
    >>> .el-dialog__body {
      background: #FFFFFF;
    }
  }
  >>> .el-dialog {
    width: 33% !important;
    .el-dialog__body {
      background: #F8F8F8;
    }
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      .dialog-footer {
        text-align: center;
        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/orderList.vue